export const URLS = {
  AUTH_CORA_VALIDATE_COUPON: '/coraSgrCoupons/validateCoupon'
}